import { useState } from 'react'
import { createContainer } from '../../../util/createContainer'

const useResourceContainer = () => {
  const [active, setActive] = useState('resources')

  const [resourceCards, setResourceCards] = useState({})

  return {
    active,
    resourceCards,

    setActive,
    setResourceCards,
  }
}

export const {
  Provider: ResourceProvider,
  useContainer: useResource,
} = createContainer(useResourceContainer)
